import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <nav className="nav">
        <div className="nav-logo">
          <Link to="/">
            <img
              src="/miyel-logo.png"
              alt="Miyel Logo"
              className="header-logo"
            />
          </Link>
        </div>
        <div className="nav-menu">
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/about" className="nav-link">About</Link>
          <Link to="/#signup" className="nav-link">Contact</Link>
        </div>
      </nav>
    </header>
  );
};

export default Header;